<template>
  <div class="content-body">
    <div class="content-title">
      {{ materialPointDetail.warehouse === 'out' ? '出库单' : '入库单' }}
    </div>
    <div class="content-head">
      <div style="width: 33%">
        {{ materialPointDetail.warehouse === 'out' ? '出库单号：' : '入库单号：'
        }}{{ materialPointDetail.orderCode }}
      </div>
      <div style="width: 33%">
        {{ materialPointDetail.warehouse === 'out' ? '计划单号：' : '送料单号：'
        }}{{ materialPointDetail.code }}
      </div>
      <div style="width: 33%">日期：{{ materialPointDetail.time }}</div>
    </div>
    <div class="content-table">
      <ml-table :pagination="false" :columns="columns" :dataSource="dataSource" bordered>
      </ml-table>
    </div>
    <div class="content-footer">
      <div style="width: 33%">
        审核人：
      </div>
      <div style="width: 33%">
        {{ materialPointDetail.warehouse === 'out' ? '出库人员：' : '收料人员：'
        }}{{ materialPointDetail.person || materialPointDetail.person }}
      </div>
      <div style="width: 33%">
        备注：
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const columns = [
  {
    title: 'page_resource_pool_no',
    dataIndex: 'key',
    width: 50
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode'
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName'
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'materialStandardModel'
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'areaName'
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'locationName'
  },
  {
    title: 'supplier',
    dataIndex: 'supplierName'
  },
  {
    title: 'page_device_repair_number',
    dataIndex: 'stockInNum'
  },
  {
    title: 'page_material_warehousing_remark',
    dataIndex: 'remark'
  }
]

export default {
  computed: {
    ...mapGetters(['materialPointDetail']),
    columns() {
      return columns.map((item) => {
        if (this.materialPointDetail.warehouse === 'out' && item.dataIndex === 'supplierName') {
          console.log(3325)
          item.title = 'page_material_warehousing_unit'
          item.dataIndex = 'materialUnit'
        }
        if (this.materialPointDetail.warehouse === 'out' && item.dataIndex === 'stockInNum') {
          item.dataIndex = 'stockOutNum'
        }
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    dataSource() {
      const data = []
      if (this.materialPointDetail.list && this.materialPointDetail.list.length) {
        this.materialPointDetail.list.forEach((res, index) => {
          res.key = index + 1
          data.push(res)
        })
      }
      return data
    }
  },
  data() {
    return {}
  },
  mounted() {
    setTimeout(() => {
      window.print()
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.content-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: bold;
  padding: 16px;
}
.content-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-footer {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// /deep/ .ant-table-row-cell-ellipsis .ant-table-column-title {
//   font-size: 12px;
// }
/deep/ .ant-table-small > .ant-table-content .ant-table-row:last-child td {
  font-size: 12px;
}
</style>
